import { IIcon } from '../interfaces'

const SvgComponent = ({ width = 20, height = 20, size, ...props }: IIcon) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'
    width={size || width}
    height={size || height}
    {...props}
  >
    <path
      fill='currentColor'
      d='m19.675 20.356.623-.623-1.856-1.856v-2.761h-.884v3.122zM5.308 20.5q-.748 0-1.278-.53a1.74 1.74 0 0 1-.53-1.278V5.308q0-.748.53-1.278t1.278-.53h13.384q.749 0 1.278.53.53.53.53 1.278v6.325a6.36 6.36 0 0 0-1.5-.442V5.308a.3.3 0 0 0-.096-.212.3.3 0 0 0-.212-.096H5.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v13.384q0 .116.096.212a.3.3 0 0 0 .212.096h5.858a5.2 5.2 0 0 0 .432 1.5zM5 18v1V5v6.19-.074zm2.25-1.366h4.017q.066-.39.194-.76.13-.37.281-.74H7.25zm0-3.884h6.34a7 7 0 0 1 1.38-.918 5.8 5.8 0 0 1 1.568-.526v-.056H7.25zm0-3.885h9.5v-1.5h-9.5zM18 22.558q-1.873 0-3.187-1.314-1.313-1.313-1.313-3.186t1.313-3.187T18 13.558t3.186 1.313 1.314 3.187-1.314 3.186Q19.874 22.558 18 22.558'
    />
  </svg>
)
export default SvgComponent
